import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fdadc1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sectors-control" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2xl" }, "Вы действительно хотите удалить?", -1))
const _hoisted_4 = { class: "font-medium mt-4" }
const _hoisted_5 = { class: "sectors-control__map" }
const _hoisted_6 = { class: "flex items-center justify-start" }
const _hoisted_7 = {
  class: "map__layer",
  id: "map_layer"
}
const _hoisted_8 = { class: "flex items-center mt-8 gap-4 justify-start" }
const _hoisted_9 = { class: "flex items-center justify-end mt-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_radio = _resolveComponent("new-radio")!
  const _component_new_sector_form = _resolveComponent("new-sector-form")!
  const _component_new_dispatcher_sector_form = _resolveComponent("new-dispatcher-sector-form")!
  const _component_new_extended_sector_form = _resolveComponent("new-extended-sector-form")!
  const _component_new_express_zone_form = _resolveComponent("new-express-zone-form")!
  const _component_new_time_slot_zone_form = _resolveComponent("new-time-slot-zone-form")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_the_checkbox = _resolveComponent("the-checkbox")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_sector_list_item = _resolveComponent("sector-list-item")!
  const _component_new_list = _resolveComponent("new-list")!
  const _component_dispatcher_sector_list_item = _resolveComponent("dispatcher-sector-list-item")!
  const _component_express_zone_list_item = _resolveComponent("express-zone-list-item")!
  const _component_time_slot_zone_list_item = _resolveComponent("time-slot-zone-list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.delete_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: _ctx.delete_state.is_express_zone ? 'Удаление экспресс зоны' : _ctx.delete_state.is_time_slot_zone ? 'Удаление сектора тайм-слотов' : 'Удаление сектора',
          "confirm-button-text": "Удалить",
          "confirm-button-class": "NewButton--danger",
          loading: _ctx.delete_state.is_loading,
          onSubmit: _ctx.deleteHandler,
          onCancel: _ctx.onCancelDeleteSector
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, [
                (_ctx.delete_state.is_express_zone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("После удаления Экспресс зоны Вы не сможете восстановить ее обратно")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("После удаления Сектора Вы не сможете восстановить его обратно")
                    ], 64))
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Управление секторами" }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_new_radio, {
          value: _ctx.state.layer,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.layer) = $event)),
          options: _ctx.MAP_LAYERS,
          "select-by": "key"
        }, null, 8, ["value", "options"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.new_sector_state.is_opened)
          ? (_openBlock(), _createBlock(_component_new_sector_form, {
              key: 0,
              "is-create": _ctx.new_sector_state.is_create,
              "is-update": _ctx.new_sector_state.is_update,
              "initial-value": _ctx.new_sector_state.initial_value,
              "dispatcher-sectors": _ctx.dispatcher_list_state.options,
              "is-paint-started": _ctx.map_paint.state.is_started,
              "is-sector-added": _ctx.isNewSectorAdded,
              loading: _ctx.new_sector_state.is_loading,
              onStartPaint: _ctx.onStartPaint,
              onCancel: _ctx.onSectorFormCancel,
              onCreate: _ctx.createSector,
              onUpdate: _ctx.updateSector
            }, null, 8, ["is-create", "is-update", "initial-value", "dispatcher-sectors", "is-paint-started", "is-sector-added", "loading", "onStartPaint", "onCancel", "onCreate", "onUpdate"]))
          : _createCommentVNode("", true),
        (_ctx.new_dispatcher_sector_state.is_opened)
          ? (_openBlock(), _createBlock(_component_new_dispatcher_sector_form, {
              key: 1,
              "is-create": _ctx.new_dispatcher_sector_state.is_create,
              "is-update": _ctx.new_dispatcher_sector_state.is_update,
              "initial-value": _ctx.new_dispatcher_sector_state.initial_value,
              "is-paint-started": _ctx.map_paint.state.is_started,
              "is-sector-added": _ctx.isNewDispatcherSectorAdded,
              loading: _ctx.new_dispatcher_sector_state.is_loading,
              onStartPaint: _ctx.onDispatcherStartPaint,
              onCancel: _ctx.onDispatcherSectorFormCancel,
              onCreate: _ctx.createDispatcherSector,
              onUpdate: _ctx.updateDispatcherSector
            }, null, 8, ["is-create", "is-update", "initial-value", "is-paint-started", "is-sector-added", "loading", "onStartPaint", "onCancel", "onCreate", "onUpdate"]))
          : _createCommentVNode("", true),
        (_ctx.new_extended_sector_state.is_opened)
          ? (_openBlock(), _createBlock(_component_new_extended_sector_form, {
              key: 2,
              "is-create": _ctx.new_extended_sector_state.is_create,
              "is-update": _ctx.new_extended_sector_state.is_update,
              "dispatcher-sector": _ctx.new_extended_sector_state.dispatcherSector,
              "is-paint-started": _ctx.map_paint.state.is_started,
              "is-sector-added": _ctx.isNewExtendedSectorAdded,
              loading: _ctx.new_extended_sector_state.is_loading,
              onCancel: _ctx.onExtendedSectorFormCancel,
              onCreate: _ctx.createExtendedSector,
              onUpdate: _ctx.updateExtendedSector
            }, null, 8, ["is-create", "is-update", "dispatcher-sector", "is-paint-started", "is-sector-added", "loading", "onCancel", "onCreate", "onUpdate"]))
          : _createCommentVNode("", true),
        (_ctx.new_express_zone_state.is_opened)
          ? (_openBlock(), _createBlock(_component_new_express_zone_form, {
              key: 3,
              "is-create": _ctx.new_express_zone_state.is_create,
              "is-update": _ctx.new_express_zone_state.is_update,
              "initial-value": _ctx.new_express_zone_state.initial_value,
              "dispatcher-sectors": _ctx.dispatcher_list_state.options,
              "is-paint-started": _ctx.map_paint.state.is_started,
              "is-sector-added": _ctx.isNewExpressZoneAdded,
              loading: _ctx.new_express_zone_state.is_loading,
              onStartPaint: _ctx.onExpressZoneStartPaint,
              onCancel: _ctx.onExpressZoneFormCancel,
              onCreate: _ctx.createExpressZone,
              onUpdate: _ctx.updateExpressZone
            }, null, 8, ["is-create", "is-update", "initial-value", "dispatcher-sectors", "is-paint-started", "is-sector-added", "loading", "onStartPaint", "onCancel", "onCreate", "onUpdate"]))
          : _createCommentVNode("", true),
        (_ctx.new_time_slot_zone_state.is_opened)
          ? (_openBlock(), _createBlock(_component_new_time_slot_zone_form, {
              key: 4,
              "is-create": _ctx.new_time_slot_zone_state.is_create,
              "is-update": _ctx.new_time_slot_zone_state.is_update,
              "initial-value": _ctx.new_time_slot_zone_state.initial_value,
              "dispatcher-sectors": _ctx.dispatcher_list_state.options,
              "is-paint-started": _ctx.map_paint.state.is_started,
              "is-sector-added": _ctx.isNewTimeSlotZoneAdded,
              loading: _ctx.new_time_slot_zone_state.is_loading,
              onStartPaint: _ctx.onTimeSlotZoneStartPaint,
              onCancel: _ctx.onTimeSlotZoneFormCancel,
              onCreate: _ctx.createTimeSlotZone,
              onUpdate: _ctx.updateTimeSlotZone
            }, null, 8, ["is-create", "is-update", "initial-value", "dispatcher-sectors", "is-paint-started", "is-sector-added", "loading", "onStartPaint", "onCancel", "onCreate", "onUpdate"]))
          : _createCommentVNode("", true),
        _createVNode(_component_new_map, {
          class: "mt-4",
          id: "dispatcher-map",
          layer: _ctx.state.layer,
          onMapReady: _ctx.onMapReady
        }, null, 8, ["layer", "onMapReady"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_new_radio, {
          value: _ctx.state.sectors,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.sectors) = $event)),
          disabled: _ctx.new_sector_state.is_create || _ctx.new_sector_state.is_update || _ctx.new_dispatcher_sector_state.is_create || _ctx.new_dispatcher_sector_state.is_update || _ctx.new_express_zone_state.is_create || _ctx.new_express_zone_state.is_update || _ctx.new_time_slot_zone_state.is_create || _ctx.new_time_slot_zone_state.is_update,
          options: _ctx.SECTORS_OPTIONS,
          "return-option": "",
          onChange: _ctx.onSectorsReload
        }, null, 8, ["value", "disabled", "options", "onChange"]),
        _createVNode(_component_the_checkbox, {
          value: _ctx.state.is_extended_sectors_showed,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.is_extended_sectors_showed) = $event)),
          disabled: _ctx.new_sector_state.is_create || _ctx.new_sector_state.is_update || _ctx.new_dispatcher_sector_state.is_create || _ctx.new_dispatcher_sector_state.is_update || _ctx.new_express_zone_state.is_create || _ctx.new_express_zone_state.is_update || _ctx.new_time_slot_zone_state.is_create || _ctx.new_time_slot_zone_state.is_update,
          label: "Внешние границы",
          onChange: _ctx.onExtendedSectorsChange
        }, null, 8, ["value", "disabled", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.state.sectors.key === 'delivery-sectors' && _ctx.isCanSectorCreate)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            class: "NewButton--outline",
            disabled: _ctx.new_sector_state.is_create || _ctx.new_sector_state.is_update,
            onClick: _ctx.onNewSector
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(" Добавить сектор курьера ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : (_ctx.state.sectors.key === 'dispatcher-sectors' && _ctx.isCanDispatcherSectorCreate)
          ? (_openBlock(), _createBlock(_component_new_button, {
              key: 1,
              class: "NewButton--outline",
              disabled: _ctx.new_dispatcher_sector_state.is_create || _ctx.new_dispatcher_sector_state.is_update,
              onClick: _ctx.onNewDispatcherSector
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" Добавить сектор диспетчера ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : (_ctx.state.sectors.key === 'express' && _ctx.isCanExpressZoneCreate)
            ? (_openBlock(), _createBlock(_component_new_button, {
                key: 2,
                class: "NewButton--outline",
                disabled: _ctx.new_express_zone_state.is_create || _ctx.new_express_zone_state.is_update,
                onClick: _ctx.onNewExpressZone
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(" Добавить экспресс зону ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : (_ctx.state.sectors.key === 'time-slot-zones' && _ctx.isCanTimeSlotZoneCreate)
              ? (_openBlock(), _createBlock(_component_new_button, {
                  key: 3,
                  class: "NewButton--outline",
                  disabled: _ctx.new_time_slot_zone_state.is_create || _ctx.new_time_slot_zone_state.is_update,
                  onClick: _ctx.onNewTimeSlotZone
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" Добавить сектор тайм-слотов ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
    ]),
    (_ctx.state.sectors.key === 'delivery-sectors')
      ? (_openBlock(), _createBlock(_component_new_list, {
          key: 1,
          class: "mt-4",
          title: _ctx.state.sectors.name,
          options: _ctx.list_state.options,
          loading: _ctx.list_state.is_loading,
          "loading-text": "Загрузка данных...",
          failed: _ctx.list_state.is_failed,
          "failed-text": "При получении данных произошла ошибка",
          onReload: _ctx.onSectorsReload
        }, {
          option: _withCtx(({ option, index }) => [
            _createVNode(_component_sector_list_item, {
              item: option,
              disabled: _ctx.new_sector_state.is_create || _ctx.new_sector_state.is_update,
              "is-can-delete": _ctx.isCanSectorDelete,
              "is-can-update": _ctx.isCanSectorUpdate,
              "is-couriers-loading": _ctx.couriers_state.is_loading,
              "is-couriers-failed": _ctx.couriers_state.is_failed,
              couriers: _ctx.couriers_state.options,
              onView: _ctx.onSectorView,
              onDelete: _ctx.onDeleteSector,
              onUpdate: ($event: any) => (_ctx.onUpdateSector(option, index)),
              onCourierAttached: _ctx.onSectorsReload,
              onCouriersReload: _ctx.loadCouriers
            }, null, 8, ["item", "disabled", "is-can-delete", "is-can-update", "is-couriers-loading", "is-couriers-failed", "couriers", "onView", "onDelete", "onUpdate", "onCourierAttached", "onCouriersReload"])
          ]),
          _: 1
        }, 8, ["title", "options", "loading", "failed", "onReload"]))
      : (_ctx.state.sectors.key === 'dispatcher-sectors')
        ? (_openBlock(), _createBlock(_component_new_list, {
            key: 2,
            class: "mt-4",
            title: _ctx.state.sectors.name,
            options: _ctx.dispatcher_list_state.options,
            loading: _ctx.dispatcher_list_state.is_loading,
            "loading-text": "Загрузка данных...",
            failed: _ctx.dispatcher_list_state.is_failed,
            "failed-text": "При получении данных произошла ошибка",
            onReload: _ctx.onSectorsReload
          }, {
            option: _withCtx(({ option, index }) => [
              _createVNode(_component_dispatcher_sector_list_item, {
                item: option,
                disabled: _ctx.new_sector_state.is_create || _ctx.new_sector_state.is_update,
                "is-can-delete": _ctx.isCanDispatcherSectorDelete,
                "is-can-update": _ctx.isCanDispatcherSectorUpdate,
                onView: _ctx.onSectorView,
                onDelete: _ctx.onDeleteSector,
                onUpdate: ($event: any) => (_ctx.onUpdateDispatcherSector(option, index)),
                onCreateExtendedSector: _ctx.onCreateExtendedSector,
                onUpdateExtendedSector: ($event: any) => (_ctx.onUpdateExtendedSector(option, index))
              }, null, 8, ["item", "disabled", "is-can-delete", "is-can-update", "onView", "onDelete", "onUpdate", "onCreateExtendedSector", "onUpdateExtendedSector"])
            ]),
            _: 1
          }, 8, ["title", "options", "loading", "failed", "onReload"]))
        : (_ctx.state.sectors.key === 'express')
          ? (_openBlock(), _createBlock(_component_new_list, {
              key: 3,
              class: "mt-4",
              title: _ctx.state.sectors.name,
              options: _ctx.express_zones_state.options,
              loading: _ctx.express_zones_state.is_loading,
              "loading-text": "Загрузка данных...",
              failed: _ctx.express_zones_state.is_failed,
              "failed-text": "При получении данных произошла ошибка",
              onReload: _ctx.onSectorsReload
            }, {
              option: _withCtx(({ option, index }) => [
                _createVNode(_component_express_zone_list_item, {
                  item: option,
                  disabled: _ctx.new_express_zone_state.is_create || _ctx.new_express_zone_state.is_update,
                  "is-can-delete": _ctx.isCanExpressZoneDelete,
                  "is-can-update": _ctx.isCanExpressZoneUpdate,
                  onView: _ctx.onSectorView,
                  onDelete: _ctx.onDeleteExpressZone,
                  onUpdate: ($event: any) => (_ctx.onUpdateExpressZone(option, index))
                }, null, 8, ["item", "disabled", "is-can-delete", "is-can-update", "onView", "onDelete", "onUpdate"])
              ]),
              _: 1
            }, 8, ["title", "options", "loading", "failed", "onReload"]))
          : (_ctx.state.sectors.key === 'time-slot-zones')
            ? (_openBlock(), _createBlock(_component_new_list, {
                key: 4,
                class: "mt-4",
                title: _ctx.state.sectors.name,
                options: _ctx.time_slot_zones_state.options,
                loading: _ctx.time_slot_zones_state.is_loading,
                "loading-text": "Загрузка данных...",
                failed: _ctx.time_slot_zones_state.is_failed,
                "failed-text": "При получении данных произошла ошибка",
                onReload: _ctx.onSectorsReload
              }, {
                option: _withCtx(({ option, index }) => [
                  _createVNode(_component_time_slot_zone_list_item, {
                    item: option,
                    disabled: _ctx.new_time_slot_zone_state.is_create || _ctx.new_time_slot_zone_state.is_update,
                    "is-can-delete": _ctx.isCanTimeSlotZoneDelete,
                    "is-can-update": _ctx.isCanTimeSlotZoneUpdate,
                    onView: _ctx.onSectorView,
                    onDelete: _ctx.onDeleteTimeSlotZone,
                    onUpdate: ($event: any) => (_ctx.onUpdateTimeSlotZone(option, index))
                  }, null, 8, ["item", "disabled", "is-can-delete", "is-can-update", "onView", "onDelete", "onUpdate"])
                ]),
                _: 1
              }, 8, ["title", "options", "loading", "failed", "onReload"]))
            : _createCommentVNode("", true)
  ]))
}